module.exports = __webpack_public_path__ + "static/media/profile.eb1794a7.svg";